import { paths } from '@/config';
import notify from '@/migration/notification';
import { useElements, useStripe } from '@stripe/react-stripe-js';
import { useState } from 'react';

export const useRegister = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
      setIsLoading(true);
      e.preventDefault();
      if (!stripe || !elements) {
        // Stripe.js hasn't yet loaded.
        // Make sure to disable form submission until Stripe.js has loaded.
        return;
      }

      const result = await stripe.confirmSetup({
        //`Elements` instance that was used to create the Payment Element
        elements,
        confirmParams: {
          return_url: `${window.location.origin}${paths.stripeCreditCallback}`,
          payment_method_data: {
            billing_details: {
              address: {
                // TODO: 日本以外の国の場合は、その国の国コードを入れる
                country: 'JP',
              },
            },
          },
        },
      });

      if (result.error) {
        notify(result.error.message, 'error', undefined, 5);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const disabled = !stripe || !elements || isLoading;

  return {
    handleSubmit,
    disabled,
    isLoading,
  };
};
